import { InfoAlert, WarningAlert } from '@/components/molecules';
import CopyButton from '@/components/molecules/CopyButton/CopyButton';
import WalletListItem from '@/components/organisms/WalletListItem/WalletListItem';
import { useWalletsContext } from '@/components/providers/postauth/UserWalletsProvider';
import APP_CONFIG from '@/config/app';
import { generateEthereumNetworkDescription } from '@/utils/functionalUtils';
import { WALLET } from '@/utils/strings';
import { FC, useMemo } from 'react';
import QRCode from 'react-qr-code';
const { MAIN_GAP } = APP_CONFIG.STYLES;
const spacingConfig = {
  gap: `gap${MAIN_GAP}`,
};
interface DepositToSelectedWalletTrayBodyProps {
  selectedWalletKey: string | null;
}
const DepositToSelectedWalletTrayBody: FC<
  DepositToSelectedWalletTrayBodyProps
> = ({ selectedWalletKey }) => {
  const { wallets } = useWalletsContext();
  const selectedWallet = useMemo(() => {
    if (!selectedWalletKey) return null;
    return wallets.find((wallet) => wallet.walletKey === selectedWalletKey) || null;
  }, [wallets, selectedWalletKey]);
  return selectedWallet ? (
    <div className={`flex flex-col items-center ${spacingConfig.gap}`}>
      <WalletListItem wallet={selectedWallet} showFullWalletAddress />
      <div className={`border-2 border-primary/10`}>
        <QRCode value={selectedWallet.address} />
      </div>
      <CopyButton
        value={selectedWallet.address}
        showLabel={true}
        labelCopied="Copied address"
        labelCopy="Copy address"
        iconSize="sm"
        displayValueSize="sm"
        displayValueColor="secondary"
      />
      {}
      {selectedWallet.blockchain === 'ethereum' && (
        <InfoAlert
          title="Transfer on Ethereum"
          description={`You can use this address to transfer assets on ${generateEthereumNetworkDescription()}`}
        />
      )}
      {selectedWallet.blockchain === 'base' && (
        <InfoAlert
          title="Transfer on Base"
          description="You can use this address to transfer assets on Base on Ethereum."
        />
      )}
      <WarningAlert
        title={WALLET.DEPOSIT_ADDRESS_WARNING_TITLE}
        description={WALLET.DEPOSIT_ADDRESS_WARNING_DESCRIPTION}
      />
    </div>
  ) : (
    <p>No network selected</p>
  );
};
export default DepositToSelectedWalletTrayBody;
